<template>
  <ExpandCard
    tour="tra_live_controls"
    data-tst="trainer_controls"
    :persistKey="'card-trainer-controls'"
    :opened="mobile"
    :closed="closed && !mobile"
    :canClose="canClose && !mobile"
    :icon="'mdi-gamepad'"
    :title="$t('common.controls')"
    :closedTooltip="$t('common.controls')"
    :style="`--max-height: ${mobile ? 'var(--vh-3)' : 'var(--vh-6-5)'}`"
    style="--content-padding: 0.75rem; --radius-open: 4px"
    class="text-noselect"
    :verticalMinified="verticalMinified"
    :hasVerticalMinify="true"
  >
    <template #default="{ open }">
      <div class="tracrls">
        <div class="tracrls_top">
          <!-- v-if produce
          Cannot read properties of null (reading 'insertBefore') -->
          <TrainerStandoff
            v-show="!verticalMinified"
            class="clr-grey"
            style="--size: 0.875rem"
            :hasSkeleton="true"
            :queryStandoff="queryStandoff"
            :hasDepth="hasStandoffDepth"
            :gameformat="gameformat"
            :customTree="customTree"
          />
          <div
            class="tracrls_igroup"
            :class="{ 'f-column': verticalMinified }"
            @click.stop
          >
            <div
              v-if="btns.includes('stop')"
              id="tra_stop"
              class="gw_btn tracrls_btn csst csst_nm"
              style="--clr-hover-white: var(--clr-error)"
              @click="configureSession"
              @mouseenter="
                e =>
                  fl_positionTooltip(e, {
                    placement: verticalMinified ? 'right' : 'bottom',
                  })
              "
            >
              <i class="mdi mdi-stop tracrls_icon"></i>
              <div
                style="position: fixed; max-width: 24rem"
                class="csst_content tracrls_btn_tooltip text-nowrap"
              >
                {{ $t('common.stop_session') }}
              </div>
            </div>
            <div
              v-if="btns.includes('new')"
              id="tra_new"
              class="gw_btn tracrls_btn csst csst_nm"
              :class="{
                ' cursor-not-allowed tracrls_btn_disabled': multipleTables,
              }"
              @click="tableNewHand(multipleTables)"
              @mouseenter="
                e =>
                  fl_positionTooltip(e, {
                    placement: verticalMinified ? 'right' : 'bottom',
                  })
              "
            >
              <i class="mdi mdi-fast-forward tracrls_icon"></i>
              <div
                class="csst_content"
                style="position: fixed; max-width: 24rem"
                v-html="
                  multipleTables
                    ? $t('tooltips.multitable_disabled_option')
                    : $t('hotkeys.practice_next_hand_key', {
                        key: hotkeys.practice_play_new_hand.displayCombination,
                      })
                "
              ></div>
            </div>
            <div
              v-if="btns.includes('repeat')"
              id="tra_repeat"
              class="gw_btn tracrls_btn csst csst_nm"
              :class="{
                'cursor-not-allowed tracrls_btn_disabled': multipleTables,
              }"
              @click="tableRepeatHand()"
              @mouseenter="
                e =>
                  fl_positionTooltip(e, {
                    placement: verticalMinified ? 'right' : 'bottom',
                  })
              "
            >
              <i class="mdi mdi-reload tracrls_icon"></i>
              <div
                class="csst_content"
                style="position: fixed; max-width: 24rem"
                v-html="
                  multipleTables
                    ? $t('tooltips.multitable_disabled_option')
                    : $t('hotkeys.practice_replay_hand_key', {
                        key: hotkeys.practice_replay_hand.displayCombination,
                      })
                "
              ></div>
            </div>
            <div
              v-if="btns.includes('configure')"
              id="tra_configure"
              data-tst="trainer_configure"
              class="gw_btn tracrls_btn csst csst_nm"
              @click="openAdvancedFilter"
              @mouseenter="
                e =>
                  fl_positionTooltip(e, {
                    placement: verticalMinified ? 'right' : 'bottom',
                  })
              "
            >
              <i class="mdi mdi-cog tracrls_icon"></i>
              <div
                class="csst_content tracrls_btn_tooltip"
                style="position: fixed; max-width: 24rem"
              >
                {{ $t('common.configure_session') }}
              </div>
            </div>
            <div
              class="z-index_3 csst csst_nm"
              @mouseenter="
                e =>
                  fl_positionTooltip(e, {
                    placement: verticalMinified ? 'right' : 'bottom',
                  })
              "
            >
              <router-link
                v-if="btns.includes('study')"
                class="gw_btn tracrls_btn clr-white"
                target="_blank"
                :to="
                  links_getLink({
                    pathName: 'StudySolutions',
                    hasTmpBoard: true,
                    asRouterLink: true,
                    namespace: activeNamespace,
                    customQuery: { soltab: 'strategy' },
                  })
                "
              >
                <i class="mdi mdi-school tracrls_icon"></i>
              </router-link>
              <!-- <div
                style="position: fixed; max-width: 24rem"
                class="csst_content tracrls_btn_tooltip"
              > -->
              <!-- {{ $t('tooltips.study_spot') }} -->
              <div
                class="csst_content tracrls_btn_tooltip"
                style="position: fixed; max-width: 24rem"
                v-html="
                  $t('hotkeys.practice_study_spot_key', {
                    key: hotkeys.practice_study_spot.displayCombination,
                  })
                "
              ></div>
              <!-- </div> -->
            </div>
            <BtnSound
              class="gw_btn tracrls_btn z-index z-index_hover"
              style="--z-index: 1; --z-index-hover: 1; --clr-hover-white: var(--clr-black-2)"
            />

            <TrainerPreferencesMenu
              v-if="!mobile"
              :namespace="namespace"
              :routerParams="preferencesRouterParams"
              tooltipPosition="right"
              class="tracrls_preferences-menu z-index z-index_hover"
              :isClosed="!open"
              style="--z-index: 0; --z-index-hover: 0"
              data-tst="trainer_preferences_menu"
              :hiddenOptions="
                verticalMinified
                  ? [
                      'fh_rng',
                      'fh_trainer_session',
                      'fh_trainer_hero_range',
                      'fh_trainer_opponent_range',
                      'fh_trainer_ranges_comparison',
                      'fh_trainer_equity_chart',
                      'fh_trainer_hand_strength',
                      'fh_trainer_total_frequency',
                      'fh_trainer_category_hands',
                      'fh_trainer_category_draws',
                      'fh_trainer_hero_strategy',
                    ]
                  : [
                      'fh_rng',
                      'fh_trainer_session',
                      'fh_trainer_grouping',
                      'fh_trainer_tables',
                      'fh_trainer_mode',
                      'fh_trainer_game_mode',
                      'fh_trainer_result',
                      'fh_trainer_hero_range',
                      'fh_trainer_opponent_range',
                      'fh_trainer_ranges_comparison',
                      'fh_trainer_equity_chart',
                      'fh_trainer_hand_strength',
                      'fh_trainer_total_frequency',
                      'fh_trainer_category_hands',
                      'fh_trainer_category_draws',
                      'fh_trainer_hero_strategy',
                    ]
              "
              @click.stop
            />
          </div>
        </div>

        <TrainerPreferences
          v-if="!verticalMinified"
          :routerParams="preferencesRouterParams"
          class="tracrls_preferences tracrls_bottom trainpref_mixed-options"
          :hiddenOptions="
            mobile
              ? ['fh_rng', 'fh_trainer_session', 'fh_trainer_tables']
              : [
                  'fh_rng',
                  'fh_trainer_learning_mode',
                  'fh_trainer_session',
                  'fh_trainer_game_speed',
                  'fh_trainer_timebank',
                  'fh_trainer_rng_visible',
                  'fh_trainer_hero_range',
                  'fh_trainer_opponent_range',
                  'fh_trainer_category_hands',
                  'fh_trainer_category_draws',
                  'fh_trainer_hero_strategy',
                  'fh_trainer_streak_visible',
                  'fh_trainer_ranges_comparison',
                  'fh_trainer_equity_chart',
                  'fh_trainer_hand_strength',
                  'fh_trainer_total_frequency',
                  'fh_trainer_hero_frequency',
                  'fh_trainer_quick_result',
                  'fh_trainer_autoplay',
                ]
          "
          :namespace="namespace"
          @updateMode="id => $emit('updateMode', id)"
        />
      </div>
    </template>
  </ExpandCard>
</template>

<script>
import ExpandCard from '@/components/Common/ExpandCard/ExpandCard'
import BtnSound from '@/components/SpecialBtns/BtnSound'
import TrainerStandoff from '@/components/Trainer/TrainerStandoff'
import TrainerPreferences from '@/components/Trainer/TrainerPreferences'
import { throttle } from 'lodash'
import TrainerPreferencesMenu from '@/components/Trainer/TrainerPreferencesMenu'
import screen_mix from '@/mixins/screen_mix'
import links_mix from '@/mixins/links_mix'
import float_mix from '@/mixins/float_mix'
import prompt_mix from '@/mixins/prompt_mix'

export default {
  name: 'TrainerControls',
  mixins: [screen_mix, links_mix, float_mix, prompt_mix],
  props: {
    namespace: { String, required: true },
    activeNamespace: String,
    closed: Boolean,
    forwardDisabled: Boolean,
    backDisabled: Boolean,
    trainerConfigure: Boolean,
    canClose: Boolean,
    hasKeydown: { type: Boolean, default: true },
    queryStandoff: Object,
    hasStandoffDepth: { type: Boolean, default: true },
    verticalMinified: Boolean,
    btns: {
      default: () => ['stop', 'new', 'repeat', 'configure', 'study'],
    },
    preferencesRouterParams: {
      type: Object,
      default: () => ({
        push: false,
        replace: false,
        saveLocally: false,
      }),
    },
  },
  emits: ['updateMode', 'go'],
  data() {
    return {}
  },
  methods: {
    go(num) {
      if (!this.forwardDisabled && num === 1) {
        this.$emit('go', num)
      } else if (!this.backDisabled && num === -1) {
        this.$emit('go', num)
      }
    },
    configureSession() {
      const sessions = this.$store.getters.history_sessions
      const lastSession = sessions[sessions.length - 1] || null
      const sessionId = this.$store.getters.session_uid
      const sessionFinished = this.$store.getters.session_finished
      if (!sessionFinished && lastSession?.uid === sessionId) {
        this.$store.dispatch(`stats_show_session_result`, lastSession)
      } else {
        this.$store.dispatch(`hands_stop`)
      }
    },
    tableNewHand: throttle(function () {
      if (!this.loadingSetup && !this.loadingSession && !this.sessionFinished) {
        this.$store.dispatch(`${this.activeNamespace}/trainer_new_hand`)
      }
    }, 1000),
    tableRepeatHand: throttle(function () {
      if (!this.loadingSetup && !this.loadingSession && !this.sessionFinished) {
        this.$store.dispatch(`${this.activeNamespace}/trainer_repeat_hand`)
      }
    }, 1000),
    openAdvancedFilter() {
      this.$store.dispatch('drills_setCheck_selected_drill', { namespace: this.namespace })
      const tmpNamespace = 'tmp/primary'
      const dialog = `trainer-advanced-filter-dialog_namespace-${this.namespace}_tmpNamespace-${tmpNamespace}_newgame`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
    toggleHeroFrequency() {
      const query = this.$store.getters[`tra/alpha/query_fullhand_setup`]
      const namespaces = ['tra/alpha', 'tra/beta', 'tra/gamma', 'tra/delta']
      namespaces.forEach(nn => {
        this.$store.dispatch(`${nn}/router_update_query`, {
          query: { fh_trainer_hero_frequency: query.fh_trainer_hero_frequency ? '' : ['on'] },
          push: false,
          replace: false,
          saveLocally: false,
        })
      })
    },
    updateQuery(query) {
      const storeAction = `${this.namespace}/router_update_query`
      this.$store.dispatch(storeAction, {
        query,
        push: false,
      })
    },
    openStudySpot() {
      const link = this.links_getLink({
        pathName: 'StudySolutions',
        hasTmpBoard: true,
        asRouterLink: true,
        namespace: this.activeNamespace,
        customQuery: { soltab: 'strategy' },
      })
      const params = new URLSearchParams(link.query)
      const path = '/solutions/'
      const url = `${window.location.origin}${path}?${params}`
      window.open(url, '_blank').focus()
    },
  },
  computed: {
    gameformat() {
      return this.$store.getters[`${this.activeNamespace}/gameformat`]
    },
    customTree() {
      return this.$store.getters[`${this.activeNamespace}/trainer_custom_tree`]
    },

    trainerSelectedPreset() {
      return this.$store.getters.drills_selected_drill
    },
    sessionFinished() {
      return this.$store.getters.session_finished
    },
    loadingSetup() {
      return this.$store.getters.api_get('api_practice_setup', this.activeNamespace)?.loading
    },
    loadingSession() {
      return this.$store.getters.api_get('api_practice_session', this.activeNamespace)?.loading
    },
    status() {
      return this.response?.status
    },
    hotkeys() {
      return this.$store.getters.hotkeys
    },
    multipleTables() {
      return this.$store.getters[`${this.namespace}/fh_trainer_tables`] > 1
    },
    hotkeysPressedBottom() {
      return this.$store.getters.hotkeys_pressed_bottom
    },
  },
  watch: {
    hotkeysPressedBottom(keys) {
      if (this.trainerConfigure) return
      if (!this.hasKeydown) return
      if (!keys) return
      // console.log(keys)
      const hotkeyActions = {
        practice_play_new_hand: {
          keys: this.hotkeys.practice_play_new_hand.keyCombination,
          fn: () => this.tableNewHand(),
        },
        practice_replay_hand: {
          keys: this.hotkeys.practice_replay_hand.keyCombination,
          fn: () => this.tableRepeatHand(),
        },
        practice_hero_frequency: {
          keys: this.hotkeys.practice_hero_frequency.keyCombination,
          fn: () => {
            this.toggleHeroFrequency()
            this.pr_dispatchMessage({ id: 'practice_hero_frequency' })
          },
        },
        practice_study_spot: {
          keys: this.hotkeys.practice_study_spot.keyCombination,
          fn: () => this.openStudySpot(),
        },
      }
      this.$store.dispatch('hotkeys_perform_action', { keys, hotkeyActions })
    },
  },
  components: {
    TrainerPreferencesMenu,
    TrainerStandoff,
    TrainerPreferences,
    BtnSound,
    ExpandCard,
  },
}
</script>
<style lang="scss" scoped>
.tracrls {
  display: flex;
  flex-direction: column;
  &_preset-name {
    font-size: 0.875rem;
    color: var(--clr-grey-2);
    font-weight: 400;
  }
  &_btn {
    --clr-hover-white: var(--clr-primary);
    --padding: 0;
    --height: 2.25rem;
    --width: 2.25rem;
    font-size: 1.5rem;
  }
  &_btn {
    z-index: 4;
    &_disabled {
      --clr-hover-white: var(--clr-black-2);
      .mdi {
        color: var(--clr-black-7);
      }
    }
  }
  &_top {
    display: flex;
    flex-direction: column;
  }
  &_bottom {
    display: flex;
    flex-direction: column;
  }
  &_preferences {
    margin: 0.5em 0 0 0;
  }
  &_icons {
    display: flex;
    align-items: center;
    grid-gap: 0.5em;
    position: relative;
    z-index: 2;
  }
  // &_icon {
  // font-size: 1.125em;
  // font-size: 1.5em;
  // margin: 0 0.25em 0 0;
  // &_arrow {
  // font-size: 1.5em;
  // }
  // }
  &_title {
    color: var(--clr-grey-2);
    // font-size: 0.8em;
    font-size: 0.875em;
    line-height: 1;
    margin-top: 1em;
  }
  &_igroup {
    display: flex;
    align-items: center;
    grid-gap: 2px;
    width: 100%;
    position: relative;
    margin: 0.25rem 0 0 0;
  }
  // &_preferences-menu {
  // position: absolute;
  // right: -0.5em;
  // }
}

@media (hover: hover) and (pointer: fine) {
  .tracrls {
    &_btn {
      &:hover {
        background: var(--clr-hover-white);
      }
    }
  }
}

@media screen and (max-width: 1023px) {
  .tracrls {
    &_top {
      order: 2;
      position: sticky;
      left: 0;
      padding: 1rem 0;
      bottom: -0.75rem;
      background: var(--clr-black-1);
      z-index: 2;
    }
    &_bottom {
      // flex-direction: column-reverse;
      order: 1;
      z-index: 1;
    }
  }
}
</style>
